import { render } from "./postSection.vue?vue&type=template&id=6f13fb36"
import script from "./postSection.vue?vue&type=script&lang=js"
export * from "./postSection.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__